import { useLanguageStore } from '@libs/stores';
var useCustomTranslation = function () {
    var key = useLanguageStore().key;
    function t(code) {
        if (!code)
            return '';
        if (!key)
            return code;
        return key[code] || code;
    }
    return t;
};
export default useCustomTranslation;
